export const translationRootUrl = './assets/i18n/';
